<template>
  <section
    class="section section-shaped section-lg my-0"
    style="padding-top:100px;"
  >
    <!-- <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
    </div> -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-11">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-center text-muted mb-4">
                <h3>Sorry, the page was NOT found!</h3>
                <a href='/'>back to home page</a>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// @ is an alias to /src

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "Page404",
  data() {
    return {};
  },
  methods: {},
  components: {},
  mounted() {
    console.log("mounted");
  },
};
</script>

<style></style>
